/**
 * Created by linjianxi on 2016/10/29.
 */
export const COUNT_DOWN = ' COUNT_DOWN '
export const CARD_BIND = ' CARD_BIND '
export const CHANGE_CHECKED = ' CHANGE_CHECKED '
export const TIME_COUNT = ' TIME_COUNT '



// WEBPACK FOOTER //
// ./src/vuex/modules/card_bind/mutation-type.js